import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from "./Header.js"
import Viewports from './Viewports'
import VideoCheck from './VideoCheck'
import LocalMediaSetting from './LocalMediaSetting'
import InvitePlayers from './InvitePlayers'
import Table from './Table'
import Controls from './Controls.js'
import GameSoundController from './GameSoundController.js'


function Room ( data ) {
  const [ getStream, setGetStream ] = useState( false ) 
  const [ localAudio, toggleLocalAudio  ] = useState( false )
  const navigate = useNavigate()


  useEffect(() => {
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    const urlParams = new URLSearchParams(window.location.search); // Get current query parameters
    const nameParam = urlParams.get('name'); // Extract the "name" parameter
  
    // Check if the user navigated directly (e.g., from an external page or reload)
    if (navigationEntry && navigationEntry.type === 'navigate' && nameParam) {
      const isReactNavigation = sessionStorage.getItem('isReactNavigation');
      if (!isReactNavigation) {
        // Redirect to `/join_room/${name}` if not React Router navigation
        navigate(`/join_room/${nameParam}`);
      }
    }
  }, [navigate]);

  // Set the React Router navigation flag before unmounting
  useEffect(() => {
    return () => {
      sessionStorage.setItem('isReactNavigation', 'true')
    };
  }, [])
  

  useEffect(() => {
    if( data.user && data.dataForRoomEntry ) setGetStream( true )
    return ( data.user ? undefined : data.toggleAuth( false ))
  }, [ data.user, data.dataForRoomEntry ])


  useEffect(() => {
    if (data.roomData && data.roomData.gameConfig && data.roomData.gameConfig.name) {
      const roomName = data.roomData.gameConfig.name; // Extract the name
      const urlParams = new URLSearchParams(window.location.search); // Get current query parameters
  
      // Check if the "name" parameter already exists
      if (!urlParams.has('name')) {
        const newUrl = `/room?name=${roomName}`; // Construct the new URL with the name parameter
        window.history.replaceState(null, '', newUrl); // Update the URL without modifying the history
      }
    }
  }, [data.roomData]);  

  useEffect(() => {
    if ( data && data.dataForRoomEntry && data.dataForRoomEntry.user && !data.dataForRoomEntry.gameConfig ) {
      data.socket.socket.emit( 'getTable', data.dataForRoomEntry )
      window.addEventListener( 'beforeunload', leftTheRoom )
      // window.addEventListener( 'unload', leftTheRoom )
    }
    return()=>{
      data.clearDataAfterExitFromRoom()
      window.removeEventListener( 'beforeunload', leftTheRoom )
      data.clearRTCmessages()
    }
  }, [])


  function leftTheRoom (){
    data.clearDataAfterExitFromRoom()
  }


  return (
    <div className='roomPageWrapper'>
      <GameSoundController
        roomData={ data.roomData }
      />

      <VideoCheck
        localVideoIsChecked={ data.localVideoIsChecked }
        setlocalVideoIsChecked={ data.setlocalVideoIsChecked }
        user={ data.user }
        localMedia={ data.localMedia }/>

      <Header
        headerContext='room'
        toggleGetChips={ data.toggleGetChips }
        user={ data.user }
        roomData={ data.roomData }
        socket={ data.socket }
        width = { data.width }/>

      <Viewports
        localMedia={ data.localMedia }
        toggleSound={ data.toggleSound }
        soundEnabled={ data.soundEnabled }
        user={ data.user }
        toggleGetChips={ data.toggleGetChips }
        roomData={ data.roomData }
        socket={ data.socket }
        RTCmessage={ data.RTCmessage }
        toggleLocalAudio={ toggleLocalAudio }
        privateData={ data.privateData }
        removeRTCMessage={ data.removeRTCMessage }
        width = { data.width }/>

      <InvitePlayers
        roomData={ data.roomData }
        privateData={ data.privateData }
        user={ data.user }/>

      <Table 
        roomData={ data.roomData }
        privateData={ data.privateData }
        user={ data.user }/>
      
      <Controls
        roomData={ data.roomData }
        user={ data.user }
        socket={ data.socket }/>

      <LocalMediaSetting
        getStream={ getStream }
        localAudio={ localAudio }
        setLocalMedia={ data.setLocalMedia }
        localMedia={ data.localMedia } />
    </div>
  )
}

export default Room